var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4267 4.00067C18.4267 3.7334 18.2671 3.49197 18.0211 3.38728C17.7752 3.28259 17.4906 3.33487 17.2979 3.52011L14.9273 5.79954C11.3977 9.19342 8.41525 13.1137 6.08614 17.4208C6.0313 17.5177 6 17.6296 6 17.7489C6 18.117 6.29848 18.4155 6.66667 18.4155H12.4133V28.0007C12.4133 28.2647 12.5691 28.5038 12.8106 28.6105C13.0521 28.7172 13.3338 28.6713 13.5289 28.4935L14.5896 27.5273C18.3026 24.1451 21.4536 20.1934 23.9243 15.8207L24.5804 14.6595C24.697 14.4531 24.6953 14.2003 24.5758 13.9956C24.4563 13.7908 24.2371 13.6649 24 13.6649H18.4267V4.00067Z",
    fill: "#A2A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.cd6470db84976426bc5293413df97349.svg";
export { ForwardRef as ReactComponent };